/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React from 'react';

import { componentFactory } from '@powdr/utils';

import { StyledCollapsePanelGroup } from './styles';

export const CollapsePanelGroup = ({
  className = '',
  largerTitleText = false,
  parentColorProfile = null,
  relationships,
  children = null,
}) => {
  if ((!relationships || relationships?.length === 0) && !children) return null;

  return (
    <StyledCollapsePanelGroup
      className={className}
      $colorProfile={parentColorProfile}
    >
      {(relationships) && componentFactory(
        relationships?.components,
        parentColorProfile,
        undefined,
        {
          largerTitleText,
        },
      )}
      {(children) && children}
    </StyledCollapsePanelGroup>
  );
};

CollapsePanelGroup.propTypes = {
  className: PropTypes.string,
  parentColorProfile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  relationships: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  children: PropTypes.node,
  largerTitleText: PropTypes.bool,
};
